import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { buildPsbt } from '../buildPsbt';
export { addWaasBitcoinExtension } from '../waas/addWaasBitcoinExtension';

export type {
  FeePriority,
  FeeRecommendations,
  UTXO,
  WaasBitcoinTransaction,
  WaasBitcoinWalletProvider
} from '../waas/WaasBitcoinWalletProvider.types';

